import { OptimizedPromptModalController } from './OptimizedPromptModal.component';
import template from './OptimizedPromptModal.view.html';
export default (params) => {
    return {
        template,
        controller: OptimizedPromptModalController,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            originalInstructions: params.originalInstructions,
            optimizedInstructions: params.optimizedInstructions,
        },
    };
};
